import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ArchiveService {
    constructor(private http: HttpClient) {}
    public archiveService(id: string, legacy: boolean) {
        const url = legacy
            ? `${environment.http.apiBaseUrl}quote/${id}/revision/0`
            : `${environment.http.quotation}quotations/service-configurator/quotes/${id}`;
        return this.http.delete(url);
    }

    public deleteVariantConfiguration(id: string) {
        return this.http.delete(`${environment.http.configuration}variant-configuration/configurations/${id}`);
    }
}
